<template>
  <div class="text-row-balance" @click="goDetails(bfbData)">
    <div class="tips">
      <p class="l-text">{{bfbData.remark}}</p>
      <p class="r-text">{{bfbData.created_time || "-- --"}}</p>
    </div>

    <div class="price out-text" v-if="bfbData.type == 1">
      +{{bfbData.money || 0}}
    </div>
    <div class="price in-text" v-if="bfbData.type == 2">
      -{{bfbData.money || 0}}
    </div>
  </div>
</template> 
  <script>
export default {
  name: "TextRowBalance",
  props: {
    bfbData: {
      type: Object,
      default: {},
    },
  },
  components: {},
  data() {
    return {
      // bfbData: {
      // "money": "金额",
      // "type": "1=充值 2=消费",
      // "remark": "备注",
      // "created_time": "日期"
      // }
    };
  },
  created() {},
  mounted() {},
  methods: {
    goDetails(Data) {
    //   this.$router.push({
    //     name: "balance-log-details",
    //     query: {
    //       id: Data.id,
    //     },
    //   });
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.text-row-balance {
  width: 100%;
  background-color: #fff;
  padding: 15px 22px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #eeeeee;

  .tips {
    padding: 0 10px;
    text-align: left;

    .l-text {
      font-size: 13px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 21px;
    }
    .r-text {
      font-size: 13px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #999999;
      line-height: 21px;
    }
  }
  .price {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 21px;
  }

  .in-text {
    color: #333333;
  }
  .out-text {
    color: #f03535;
  }
}
</style>
  